import { createContext, useContext } from 'react';
import PropTypes from 'prop-types';
export const ActiveTaskIdContext = /*#__PURE__*/createContext(undefined);
ActiveTaskIdContext.Provider.propTypes = {
  value: PropTypes.number
};
export function useActiveTaskIdContext() {
  return useContext(ActiveTaskIdContext);
}